import { render, staticRenderFns } from "./logoutNotice.vue?vue&type=template&id=7b6138d8&scoped=true&"
import script from "./logoutNotice.vue?vue&type=script&lang=js&"
export * from "./logoutNotice.vue?vue&type=script&lang=js&"
import style0 from "./logoutNotice.vue?vue&type=style&index=0&id=7b6138d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6138d8",
  null
  
)

export default component.exports